import Registry from "../registry";
import React from "react";
import Files from "../components/fields/Files";
import utils from "../lib/utils";
import t from "tcomb-form";

const file = {
  name: "File",
  group: "Content",
  options: {
    file_limit: {
      label: "File Limit",
      help: "Leave blank for no limit"
    },
    file_types: {
      label: "Allowed File Types"
    },
    publicUrl: {
      label: "Public URL",
      help: "Provide a publicly accessible url through the api.",
      type: "boolean"
    }
  },
  schema: part => ({
    type: "list",
    of: {
      type: "structure",
      fields: {
        name: { type: "string" },
        url: { type: "string" },
        size: { type: "number" }
      }
    },
    factory: t.form.Textbox,
    component: ({ value, onChange }) => (
      <Files
        value={value || []}
        onChange={onChange}
        limit={parseInt(part.file_limit) || 0}
        accepted={part.file_types || ""}
        publicUrl={part.publicUrl || false}
      />
    ),
    render: ({ value }) => {
      const file = Array.isArray(value) ? value[0] : value;
      if (file && file.name) {
        return (
          <a href={utils.fileUrl(file)} target="_blank">
            {file.name}
          </a>
        );
      }

      return <span>Empty</span>;
    }
  })
};

Registry.register("file", file);
export default file;



// WEBPACK FOOTER //
// ./app/parts/file.js